import { Link } from "react-router-dom";
import { formatRupiah } from "../../utils/formatter";
import { getBaseUrl } from "../../api/baseApi";

const BASE_URL = getBaseUrl();

const getImageUrl = (photo) => {
    if (!photo) return "";

    try {
        // Coba parse JSON array
        const parsed = JSON.parse(photo);
        if (Array.isArray(parsed) && parsed.length > 0) {
            return BASE_URL + parsed[0]; // gunakan gambar pertama
        }
    } catch (err) {
        // Jika bukan JSON → gunakan langsung
        return BASE_URL + photo;
    }

    return ""; // fallback
};

function PropertyCard({ property }) {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
        <div className="col-xl-4 col-sm-6 col-12">
            <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                <div className="product-img go-top">
                    <Link
                        to={`/product-details/${property?.property_type ?? ""}/${property?.id ?? ""
                            }`}
                    >
                        <img
                            src={getImageUrl(property.photo)}
                            alt={property.name}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: 6,
                                maxHeight: "300px" // optional biar tidak terlalu tinggi jika gambar besar
                            }}
                            onError={(e) => {
                                e.target.src = publicUrl + "assets/img/product-3/2.jpg";
                            }}
                        />

                    </Link>
                </div>
                <div className="product-info">
                    <div className="product-badge">
                        <ul>
                            <li className="sale-badg">{property.property_type}</li>
                        </ul>
                    </div>
                    <h2 className="product-title go-top">
                        <Link
                            to={`/product-details/${property?.property_type ?? ""}/${property?.id ?? ""
                                }`}
                        >
                            {property.name}
                        </Link>
                    </h2>
                    <div className="product-img-location">
                        <ul>
                            <li>
                                <Link>
                                    <i className="flaticon-pin" /> {property.province},{" "}
                                    {property.city}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                        <li>
                            <span>
                                {property.min_rent} {property.rent_type}{" "}
                            </span>
                            Minimum Rent
                        </li>

                        <li>
                            <span>{property.building_area} </span>
                            Sqm
                        </li>
                    </ul>
                </div>
                <div className="product-info-bottom">
                    <div className="product-price">
                        <span>
                            {formatRupiah(property.rent_price)}
                            <label>/{property.rent_type}</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PropertyCard;
